import {Pipe, PipeTransform} from '@angular/core';
import {Observable, from, of} from 'rxjs';
import {catchError, shareReplay, startWith} from 'rxjs/operators';
import {MediaOfflineService, MediaOfflineType} from '../services/media-offline.service';

@Pipe({
  name: 'offlineMedia',
  standalone: false,
})
export class OfflineMediaPipe implements PipeTransform {
  private readonly memoized = new Map<string, Observable<string>>();

  constructor(private readonly mediaOffline: MediaOfflineService) {}

  transform(url: string | null | undefined, typeHint: MediaOfflineType = 'unknown'): Observable<string> {
    if (!url) {
      return of('');
    }
    const key = `${typeHint}:${url}`;
    const cached = this.memoized.get(key);
    if (cached) {
      return cached;
    }

    const stream = from(this.mediaOffline.resolveUrl(url, typeHint)).pipe(
      startWith(url),
      catchError(() => of(url)),
      shareReplay({bufferSize: 1, refCount: true})
    );
    this.memoized.set(key, stream);
    return stream;
  }
}
